import React from "react";
import Header from "../../reusable/Header/Header";
import TopBarTab from "../../reusable/TopBarTab/TopBarTab";
import TabContainer from "../../reusable/TopBarTabContainer/TabContainer";

export default function TopBar() {
	return (
		<Header>
			<TabContainer>
				<TopBarTab title="Slides" active={true} />
			</TabContainer>
		</Header>
	);
}
